module.exports = __webpack_public_path__ + "static/media/ballare.bbb67d00.jpeg";